import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Home from "./components/Home";
// import HomeLogin from "./components/HomeLogin";
// import MyAccountLayout from "./components/my-account/Layout";
// import MyAccountProfile from "./components/my-account/Profile";
// import MyAccountMyOrders from "./components/my-account/MyOrders";
// import MyAccountTrackMyOrder from "./components/my-account/TrackMyOrder";

// import AdminOrders from "./components/admin/Orders";
// import AdminProducts from "./components/admin/Products";
// import AdminProductCategories from "./components/admin/ProductCategories";
// import AdminPremiumItems from "./components/admin/PremiumItems";
// import AdminOffers from "./components/admin/Offers";
// import AdminPromoCodes from "./components/admin/PromoCodes";
// import AdminSettings from "./components/admin/Settings";

// import DepartmentsList from "./components/DepartmentsList";
// import MoneyAccountsList from "./components/MoneyAccountsList";
// import MoneyTransfersList from "./components/MoneyTransfersList";
import AccountHeadsList from "./components/AccountHeadsList";
// import ContactsList from "./components/ContactsList";
// import InvoicesList from "./components/InvoicesList";
// import BillTypesList from "./components/BillTypesList";
// import BillsList from "./components/BillsList";
// import PaymentsList from "./components/PaymentsList";
// import LoansList from "./components/LoansList";
// import ExpensesList from "./components/ExpensesList";

// import DailyExpenseReport from "./components/reports/DailyExpenseReport";
// import DailyReceivedReport from "./components/reports/DailyReceivedReport";
// import InvoiceDuesReport from "./components/reports/InvoiceDuesReport";
// import BillDuesReport from "./components/reports/BillDuesReport";
// import LoanDuesReport from "./components/reports/LoanDuesReport";
// import MonthlyCashInflows from "./components/reports/MonthlyCashInflows";
// import MonthlyCashOutflows from "./components/reports/MonthlyCashOutflows";
// import MonthlyProfitLoss from "./components/reports/MonthlyProfitLoss";

// Doctor Prescriptions start

// import MedicineTypeList from "./components/medicine/MedicineTypeList";
// import AppointmentList from "./components/appointment/AppointmentList";
// import MedicineList from "./components/medicine/MedicineList";
// import PatientList from "./components/patient/PatientList";
// import PrescriptionLeftSectionsList from "./components/prescription/PrescriptionLeftSectionList";
// import PrescriptionAdd from "./components/prescription/PrescriptionAdd";
// import PrescriptionList from "./components/prescription/PrescriptionList";

// Doctor Prescriptions en

// Doctor Prescriptions start

import ClientList from "./components/client/ClientList";
import CoordinatorList from "./components/coordinator/CoordinatorList";
// import ProjectList from "./components/project/ProjectList";
import CompanyList from "./components/company/CompanyList";
import ExpenseList from "./components/expense/ExpenseList";
import InvoiceList from "./components/invoice/InvoiceList";
import InvoiceDuesReport from "./components/reports/InvoiceDuesReport";
import InvoiceReport from "./components/reports/InvoiceReport";
import CompanyReport from "./components/reports/CompanyReport";
import ExpenseReport from "./components/reports/ExpenseReport";


// Doctor Prescriptions end

Vue.use(Router);

const permissions = {
  // my_account_profile: ["customer", "admin"],
  // my_account_my_orders: ["customer"],
  // my_account_track_my_orders: ["customer"],
  // admin_orders: ["admin"],
  // admin_products: ["admin"],
  // admin_product_categories: ["admin"],
  // admin_premium_items: ["admin"],
  // admin_offers: ["admin"],
  // admin_promo_codes: ["admin"],
  // admin_settings: ["admin"],

  // departments: ["admin"],
  // money_accounts: ["admin"],
  account_heads: ["sadmin", "admin"],
  // contacts: ["admin"],
  // payments: ["admin"],
  // loans: ["admin"],
  expenses: ["sadmin", "admin"],
  // daily_expense_report: ["sadmin", "admin"],
  // daily_received_report: ["sadmin", "admin"],

  // medicine_types: ["admin", "doctor"],
  // appointments: ["admin", "doctor"],
  // medicines: ["admin", "doctor"],
  // patients: ["admin", "doctor", "compunder"],
  // prescription_left_sections: ["admin", "doctor"],
  // prescription_add: ["admin", "doctor"],
  // prescriptions: ["admin", "doctor", "comp"],

  
  // agents: ["sadmin", "admin"],
  // employers: ["sadmin", "admin"],
  // projects: ["sadmin", "admin"],
  invoices: ["sadmin", "admin"],
};

const hasPermission = (to, from, next) => {
  let logged = store.getters["common/logged"];
  let loggedRole = logged.user ? logged.user.role : "guest";
  const allowedRoles = permissions[to.name];
  if (allowedRoles && !allowedRoles.includes(loggedRole)) {
    next("/");
    return;
  }
  next();
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/expenses",
      name: "expenses",
      component: ExpenseList,
      beforeEnter: hasPermission,
      meta: { title: "Expense List" },
    },
    {
      path: "/invoices",
      name: "invoices",
      component: InvoiceList,
      beforeEnter: hasPermission,
      meta: { title: "Invoice List" },
    },
    {
      path: "/clients",
      name: "clients",
      component: ClientList,
      beforeEnter: hasPermission,
      meta: { title: "Clients List" },
    },
    {
      path: "/coordinators",
      name: "coordinators",
      component: CoordinatorList,
      beforeEnter: hasPermission,
      meta: { title: "Coordinators List" },
    },
    {
      path: "/companies",
      name: "companies",
      component: CompanyList,
      beforeEnter: hasPermission,
      meta: { title: "Employer List" },
    },
    {
      path: "/invoice_report",
      name: "invoice_report",
      component: InvoiceReport,
      beforeEnter: hasPermission,
      meta: { title: "Invoice Report" },
    },
    {
      path: "/company_report",
      name: "company_report",
      component: CompanyReport,
      beforeEnter: hasPermission,
      meta: { title: "Company Report" },
    },
    {
      path: "/due-invoice-report",
      name: "due_invoice_report",
      component: InvoiceDuesReport,
      beforeEnter: hasPermission,
      meta: { title: "Due Invoice Report" },
    },
    {
      path: "/expense-report",
      name: "expense_report",
      component: ExpenseReport,
      beforeEnter: hasPermission,
      meta: { title: "Expense Report" },
    },
    {
      path: "/account_heads",
      name: "account_heads",
      component: AccountHeadsList,
      beforeEnter: hasPermission,
      meta: { title: "Account Heads List" },
    },
    // {
    //   path: "/projects",
    //   name: "projects",
    //   component: ProjectList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Project List" },
    // },
    // {
    //   path: "/projects_report",
    //   name: "projects_report",
    //   component: ProjectReport,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Project Report" },
    // },
    // {
    //   path: "/appointments",
    //   name: "appointments",
    //   component: AppointmentList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Appointments List" },
    // },
    // {
    //   path: "/prescriptions",
    //   name: "prescriptions",
    //   component: PrescriptionList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Prescription List" },
    // },
    // {
    //   path: "/prescription_add",
    //   name: "prescription_add",
    //   component: PrescriptionAdd,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Prescription Add" },
    // },
    // {
    //   path: "/medicines",
    //   name: "medicines",
    //   component: MedicineList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Medicine List" },
    // },
    // {
    //   path: "/medicine_types",
    //   name: "medicine_types",
    //   component: MedicineTypeList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Medicine Type List" },
    // },
    // {
    //   path: "/patients",
    //   name: "patients",
    //   component: PatientList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Patient List" },
    // },
    // {
    //   path: "/prescription_left_sections",
    //   name: "prescription_left_sections",
    //   component: PrescriptionLeftSectionsList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Sections List" },
    // },
    // {
    //   path: "/departments",
    //   name: "departments",
    //   component: DepartmentsList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Departments List" },
    // },
    // {
    //   path: "/money_accounts",
    //   name: "money_accounts",
    //   component: MoneyAccountsList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Money Accounts List" },
    // },
    // {
    //   path: "/money_transfers",
    //   name: "money_transfers",
    //   component: MoneyTransfersList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Money Transfers List" },
    // },
    // {
    //   path: "/contacts",
    //   name: "contacts",
    //   component: ContactsList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Contacts List" },
    // },
    // {
    //   path: "/invoices",
    //   name: "invoices",
    //   component: InvoicesList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Invoices List" },
    // },
    // {
    //   path: "/bill_types",
    //   name: "bill_types",
    //   component: BillTypesList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Bill Types List" },
    // },
    // {
    //   path: "/bills",
    //   name: "bills",
    //   component: BillsList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Bills List" },
    // },
    // {
    //   path: "/payments",
    //   name: "payments",
    //   component: PaymentsList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Payments List" },
    // },
    // {
    //   path: "/loans",
    //   name: "loans",
    //   component: LoansList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Loans List" },
    // },
    // {
    //   path: "/expenses",
    //   name: "expenses",
    //   component: ExpensesList,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Expense List" },
    // },
    // {
    //   path: "/daily_expense_report",
    //   name: "daily_expense_report",
    //   component: DailyExpenseReport,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Daily expense report" },
    // },
    // {
    //   path: "/daily_received_report",
    //   name: "daily_received_report",
    //   component: DailyReceivedReport,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Daily received report" },
    // },
    // {
    //   path: "/invoice_dues_report",
    //   name: "invoice_dues_report",
    //   component: InvoiceDuesReport,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Invoice Dues report" },
    // },
    // {
    //   path: "/bill_dues_report",
    //   name: "bill_dues_report",
    //   component: BillDuesReport,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Bill Dues report" },
    // },
    // {
    //   path: "/loan_dues_report",
    //   name: "loan_dues_report",
    //   component: LoanDuesReport,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Loan Dues report" },
    // },
    // {
    //   path: "/monthly_profit_loss",
    //   name: "monthly_profit_loss",
    //   component: MonthlyProfitLoss,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Monthly Profit & Loss" },
    // },
    // {
    //   path: "/monthly_cash_inflows",
    //   name: "monthly_cash_inflows",
    //   component: MonthlyCashInflows,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Cash inflows" },
    // },
    // {
    //   path: "/monthly_cash_outflows",
    //   name: "monthly_cash_outflows",
    //   component: MonthlyCashOutflows,
    //   beforeEnter: hasPermission,
    //   meta: { title: "Cash outflows" },
    // },
    // {
    //   path: "/my-account",
    //   name: "my_account_home",
    //   component: MyAccountLayout,
    //   redirect: "my-account/profile",
    //   children: [
    //     {
    //       path: "profile",
    //       name: "my_account_profile",
    //       component: MyAccountProfile,
    //       beforeEnter: hasPermission,
    //       meta: { title: "My Profile" },
    //     },
    //     {
    //       path: "my-orders",
    //       name: "my_account_my_orders",
    //       component: MyAccountMyOrders,
    //       beforeEnter: hasPermission,
    //       meta: { title: "My Orders" },
    //     },
    //     {
    //       path: "track-my-orders",
    //       name: "my_account_track_my_orders",
    //       component: MyAccountTrackMyOrder,
    //       beforeEnter: hasPermission,
    //       meta: { title: "Track My Order" },
    //     },
    //     {
    //       path: "orders",
    //       name: "admin_orders",
    //       component: AdminOrders,
    //       beforeEnter: hasPermission,
    //       meta: { title: "All Orders" },
    //     },
    //     {
    //       path: "products",
    //       name: "admin_products",
    //       component: AdminProducts,
    //       beforeEnter: hasPermission,
    //       meta: { title: "Service Items" },
    //     },
    //     {
    //       path: "product-categories",
    //       name: "admin_product_categories",
    //       component: AdminProductCategories,
    //       beforeEnter: hasPermission,
    //       meta: { title: "Item Categories" },
    //     },
    //     {
    //       path: "premium-items",
    //       name: "admin_premium_items",
    //       component: AdminPremiumItems,
    //       beforeEnter: hasPermission,
    //       meta: { title: "Premium Items" },
    //     },
    //     {
    //       path: "offers",
    //       name: "admin_offers",
    //       component: AdminOffers,
    //       beforeEnter: hasPermission,
    //       meta: { title: "Offers" },
    //     },
    //     {
    //       path: "promo-codes",
    //       name: "admin_promo_codes",
    //       component: AdminPromoCodes,
    //       beforeEnter: hasPermission,
    //       meta: { title: "Promo Codes" },
    //     },
    //     {
    //       path: "settings",
    //       name: "admin_settings",
    //       component: AdminSettings,
    //       beforeEnter: hasPermission,
    //       meta: { title: "Settings" },
    //     },
    //   ],
    // },
  ],
});

//To ingnore the error "NavigationDuplicated: Avoided redundant"
function patchRouterMethod(router, methodName) {
  router["old" + methodName] = router[methodName];
  router[methodName] = async function(location) {
    return router["old" + methodName](location).catch((error) => {
      if (error.name === "NavigationDuplicated") {
        return this.currentRoute;
      }
      throw error;
    });
  };
}

patchRouterMethod(router, "push");
patchRouterMethod(router, "replace");

export default router;
